import { Header } from '@/components/Header';
import { Hero } from '@/components/Hero';
import { Showreel } from '@/components/Showreel';
import { About } from '@/components/About';

import { Vision } from '@/components/Vision';
import { Services } from '@/components/Services';
import { Achievements } from '@/components/Achievements';
import { Partners } from '@/components/Partners';
import { News } from '@/components/News';
import { Contact } from '@/components/Contact';
import { Footer } from '@/components/Footer';
import { SectionNavigator } from '@/components/SectionNavigator';

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <SectionNavigator />
      <Hero />
      <Showreel />
      <About />
      <Vision />
      <Services />
      <Achievements />
      <Partners />
      <News />
      <Contact />
      <Footer />
    </div>
  );
};

export default Index;
